<template>
  <div>
    <!-- 分组列表 -->
    <div v-if="!showDetails">
      <div class="grid-content maintitle">
        <span>特殊外部字段分组</span>
      </div>

      <div class="grid-content content-margin">
        <div class="buttonarea">
          <el-link :underline="false">
            <el-button
              size="medium"
              round
              @click.native="
                showDetails = true;
                isEditMode = true;
                resetGroupDetails();
                groupAdd = true;
              "
            >
              <i class="iconfont">&#xe727;</i>
              {{ $t("message.新增") }}
            </el-button>
          </el-link>
        </div>
      </div>
        <!-- <el-divider></el-divider> -->
       <div class="grid-content content-margin">
        <el-table
          ref="table"
          :data="groupList"
          stripe
          border
          :height="tableHeight"
          style="width: 100%"
        >
          <el-table-column
            width="200"
            :label="$t('message.操作')"
            align="center"
          >
            <template slot-scope="scope">
              <el-button-group>
                <el-button
                  size="mini"
                  round
                  type="normal"
                  icon="el-icon-view"
                  @click="
                    editGroup(scope.row, false);
                    groupAdd = false;
                  "
                ></el-button>
                <el-button
                  size="mini"
                  round
                  type="normal"
                  icon="el-icon-edit"
                  @click="
                    editGroup(scope.row, true);
                    groupAdd = false;
                  "
                ></el-button>
                <el-button
                  size="mini"
                  round
                  type="normal"
                  icon="el-icon-delete"
                  @click="
                    deleteGroupRow = scope.row;
                    deleteDialogVisible = true;
                  "
                ></el-button>
              </el-button-group>
            </template>
          </el-table-column>

          <el-table-column prop="groupid" label="分组id" width="150">
          </el-table-column>

          <el-table-column prop="name" label="分组名称"> </el-table-column>
        </el-table>
      </div>
    </div>

    <!-- 分组详情 -->
    <div v-if="showDetails">
      <!-- 标题 -->
      <div class="grid-content maintitle">
        <span>分组详细信息</span>
      </div>

      <!-- 按键区域 -->
      <div class="grid-content content-margin">
        <div class="buttonarea">
          <el-link :underline="false">
            <el-button
              size="medium"
              round
              @click.native="backToList()"
              icon="el-icon-back"
            >
              {{ $t("message.返回") }}
            </el-button>
            <el-button
              size="medium"
              round
              v-if="!isEditMode"
              @click.native="
                isEditMode = true;
                groupAdd = false;
              "
              icon="el-icon-edit"
            >
              {{ $t("message.编辑") }}
            </el-button>

            <el-button
              size="medium"
              round
              v-if="isEditMode"
              @click.native="onSave()"
            >
              <i class="iconfont">&#xe769;</i>
              {{ $t("message.保存") }}
            </el-button>
          </el-link>
        </div>
      </div>

      <div class="grid-content subtitle">
        <span>分组主信息</span>
      </div>
      <div class="grid-content content-margin">
        <table class="simpleRow">
          <tr>
            <td>
              <span class="simpleLabel">分组名称</span>
            </td>
            <td>
              <el-input
                :readonly="!isEditMode"
                size="mini"
                class="linkTextArea"
                v-model="groupDetails.group.name"
                type="textarea"
                placeholder="请输入分组名称"
                maxlength="50"
                show-word-limit
              >
              </el-input>
            </td>
          </tr>
        </table>
      </div>

      <div class="grid-content subtitle">
        <span>特殊外部字段信息</span>
      </div>

      <div class="grid-content content-margin" v-if="isEditMode">
        <div class="buttonarea">
          <el-link :underline="false">
            <el-button
              size="medium"
              round
              @click.native="
                showFieldDetails = true;
                resetFieldDetails();
                fieldAdd = true;
              "
              icon="el-icon-plus"
            >
              {{ $t("message.新增") }}
            </el-button>
          </el-link>
        </div>
      </div>

      <div class="grid-content content-margin">
        <!-- 字段表 -->
        <el-table
          ref="table"
          :data="groupDetails.details"
          stripe
          border
          :height="tableHeight"
          style="width: 100%"
        >
          <el-table-column
            width="200"
            :label="$t('message.操作')"
            align="center"
          >
            <template slot-scope="scope">
              <el-button-group>
                <el-button
                  size="mini"
                  round
                  type="normal"
                  icon="el-icon-view"
                  v-if="!isEditMode"
                  @click="editField(scope.row)"
                ></el-button>
                <el-button
                  size="mini"
                  round
                  type="normal"
                  icon="el-icon-edit"
                  @click="editField(scope.row)"
                  v-if="isEditMode"
                ></el-button>
                <el-button
                  size="mini"
                  round
                  type="normal"
                  icon="el-icon-delete"
                  v-if="isEditMode"
                  @click="deleteField(scope.row)"
                ></el-button>
              </el-button-group>
            </template>
          </el-table-column>

          <el-table-column
            prop="externalfieldname"
            label="外部字段名"
            width="225"
          >
          </el-table-column>

          <el-table-column prop="fieldname" label="元数据字段名" width="225">
          </el-table-column>

          <el-table-column prop="name" label="中文名" width="150">
          </el-table-column>

          <el-table-column prop="targettable" label="数据源" width="225">
            <template slot-scope="scope">
              <div>
                <span>{{ getTableName(scope.row.targettable) }}</span>
              </div>
            </template>
          </el-table-column>

          <el-table-column prop="attrgenre" label="数据类型" width="150">
          </el-table-column>

          <el-table-column prop="attrlength" label="数据长度">
          </el-table-column>
        </el-table>
      </div>
    </div>

    <!-- 删除确认框 -->
    <el-dialog
      :title="$t('message.删除确认')"
      :visible.sync="deleteDialogVisible"
      width="300px"
      :modal="false"
      center
      :before-close="handleClose"
    >
      <i class="iconfont">&#xe766;</i>
      <span>{{ $t("message.请确认是否删除该内容") }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="deleteDialogVisible = false">{{
          $t("message.取消")
        }}</el-button>
        <el-button type="primary" @click.native="deleteGroup">{{
          $t("message.删除")
        }}</el-button>
      </span>
    </el-dialog>

    <!-- 字段详情编辑 -->
    <el-drawer
      :show-close="false"
      :size="800"
      :visible.sync="showFieldDetails"
      :direction="'rtl'"
      :before-close="handleClose"
    >
      <div class="grid-content subtitle">
        <span>外部字段转换设置</span>
      </div>
      <div class="grid-content content-margin">
        <div class="buttonarea">
          <el-link :underline="false">
            <el-button
              size="medium"
              round
              @click.native="showFieldDetails = false"
              icon="el-icon-back"
            >
              {{ $t("message.返回") }}
            </el-button>
          </el-link>
          <el-link :underline="false">
            <el-button
              size="medium"
              round
              v-if="isEditMode"
              @click.native="addFieldDetail"
            >
              <i class="iconfont">&#xe769;</i>
              {{ $t("message.确定") }}
            </el-button>
          </el-link>
        </div>
        <el-divider></el-divider>
      </div>
      <div class="grid-content content-margin">
        <table class="simpleRow">
          <!-- 类型选择 -->
          <tr>
            <td>
              <span class="simpleLabel">数据来源</span>
            </td>

            <td>
              <el-select
                v-model="fieldDetails.targettable"
                placeholder="请选择"
                size="small"
                @change="getTableField"
                :disabled="!isEditMode"
              >
                <el-option
                  v-for="item in typeOptions"
                  :key="item.value"
                  :label="item.name + ':' + item.define"
                  :value="item.value"
                  :disabled="item.disabled"
                >
                </el-option>
              </el-select>
            </td>
          </tr>

          <tr>
            <td>
              <span class="simpleLabel">元数据字段</span>
            </td>
            <td>
              <el-select
                v-model="fieldDetails.fieldid"
                placeholder="请选择"
                size="small"
                :disabled="!isEditMode"
                @change="handleSelectChange"
              >
                <el-option
                  v-for="item in fieldData"
                  :key="item.fieldid"
                  :label="item.fieldname + ':' + item.name"
                  :value="item.fieldid"
                  :disabled="item.disabled"
                >
                </el-option>
              </el-select>
            </td>
          </tr>

          <tr>
            <td>
              <span class="simpleLabel">外部数据字段</span>
            </td>
            <td>
              <el-input
                v-model="fieldDetails.externalfieldname"
                placeholder="请选择"
                size="small"
                :disabled="!isEditMode"
              ></el-input>
            </td>
          </tr>
        </table>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import { rejecthttp, changeflagCLOSED } from "@/utils/request";
import userTableType from "@/utils/UserTableType";
import shade from "@/components/shade/shade";
export default {
  name: "ApiAccount",
  data() {
    return {
      appID: 188,
      tableHeight: 500,
      typeOptions: [],
      groupList: [],
      selectGroup: 0,
      groupDetails: {},
      showDetails: false,
      showFieldDetails: false,
      isEditMode: false,
      deleteGroupRow: {},
      deleteDialogVisible: false,
      fieldDetails: {},
      fieldData: [],
      fieldAdd: false,
      groupAdd: false,
      selectRow: false,
    };
  },

  components: {
    shade,
  },

  methods: {
    resetFieldDetails() {
      this.fieldDetails = {
        targettable: null,
        fieldid: null,
        externalfieldname: null,
      };
    },

    resetGroupDetails() {
      this.groupDetails = {
        details: [],
        group: { name: "", appid: this.appID },
      };
    },

    backToList() {
      this.showDetails = false;
      this.isEditMode = false;
      this.refreshList();
    },

    deleteGroup() {
      console.log(this.deleteGroupRow);

      rejecthttp(
        true,
        "get",
        "/manage/fieldtrans/delgroup",
        {
          appid: this.appID,
          groupid: this.deleteGroupRow.groupid,
        },
        this,
        (doc) => {
          changeflagCLOSED(doc, 0, this);
          if (doc.data.Code == "MSGKEY_OK") {
            this.refreshList();
            this.$message({
              type: "success",
              message: doc.data.Message,
            });
          } else {
            this.$message({
              type: "error",
              message: doc.data.Message,
            });
          }
        }
      );

      this.deleteGroupRow = null;
      this.deleteDialogVisible = false;
      this.refreshList();
    },

    editGroup(group, isEdit) {
      this.isEditMode = isEdit;
      this.showDetails = true;
      this.getGroup(group.groupid);
    },

    getTableName(tableID) {
      for (let i = 0; i < this.typeOptions.length; ++i) {
        if (this.typeOptions[i].value == tableID) {
          return this.typeOptions[i].name;
        }
      }
    },

    getTableField() {
      this.fieldDetails.fieldid = null;
      rejecthttp(
        true,
        "get",
        "/manage/fieldtrans/gettablefields",
        {
          appid: this.appID,
          tableid: this.fieldDetails.targettable,
        },
        this,
        (doc) => {
          changeflagCLOSED(doc, 0, this);
          if (doc.data.Code == "MSGKEY_OK") {
            this.fieldData = doc.data.data;
          } else {
            this.$message({
              type: "error",
              message: doc.data.Message,
            });
          }
        }
      );
    },

    getGroup(row) {
      rejecthttp(
        true,
        "get",
        "/manage/fieldtrans/getgroupdetail",
        {
          appid: this.appID,
          groupid: row,
        },
        this,
        (doc) => {
          changeflagCLOSED(doc, 0, this);
          if (doc.data.Code == "MSGKEY_OK") {
            this.groupDetails = doc.data.data;
            console.log(this.groupDetails);
          } else {
            this.$message({
              type: "error",
              message: doc.data.Message,
            });
          }
        }
      );
    },

    refreshList() {
      rejecthttp(
        true,
        "get",
        "/manage/fieldtrans/getgrouplist",
        {
          appid: this.appID,
        },
        this,
        (doc) => {
          changeflagCLOSED(doc, 0, this);
          if (doc.data.Code == "MSGKEY_OK") {
            this.groupList = doc.data.data;
          } else {
            this.$message({
              type: "error",
              message: doc.data.Message,
            });
          }
        }
      );
    },

    handleSelectChange(row) {
      for (let i = 0; i < this.fieldData.length; ++i) {
        if (this.fieldData[i].fieldid == row) {
          this.fieldDetails.fieldname = this.fieldData[i].fieldname;
          this.fieldDetails.name = this.fieldData[i].name;
          this.fieldDetails.targettable = this.fieldData[i].targettable;
          this.fieldDetails.attrgenre = this.fieldData[i].attrgenre;
          this.fieldDetails.attrlength = this.fieldData[i].attrlength;
        }
      }
    },

    addFieldDetail() {
      //获取配置
      if (
        this.fieldDetails.fieldid == null ||
        this.fieldDetails.externalfieldname == null ||
        this.fieldDetails.externalfieldname.length == 0
      ) {
        this.$message({
          type: "error",
          message: "字段不能为空",
        });
        return;
      }

      //检查重复
      for (let i = 0; i < this.groupDetails.details.length; i++) {
        if (
          !this.fieldAdd &&
          this.groupDetails.details[i].fieldid == this.selectRow
        ) {
          console.log(this.fieldDetails);
          this.$set(
            this.groupDetails.details,
            i,
            JSON.parse(JSON.stringify(this.fieldDetails))
          );
          this.showFieldDetails = false;
          return;
        }

        // if (
        //   this.fieldDetails.externalfieldname ==
        //   this.groupDetails.details[i].externalfieldname
        // ) {
        //   this.$message({
        //     type: "error",
        //     message: "外部数据字段重复",
        //   });
        //   return;
        // }
      }

      for (let i = 0; i < this.fieldData.length; ++i) {
        if (this.fieldData[i].fieldid == this.fieldDetails.fieldid) {
          var temp = JSON.parse(JSON.stringify(this.fieldData[i]));
          temp.externalfieldname = this.fieldDetails.externalfieldname;
          this.groupDetails.details.push(temp);
        }
      }
      this.showFieldDetails = false;
    },

    handleClose(done) {
      // 空函数, 防止dialog被不小心关闭
    },

    onSave() {
      if (
        this.groupDetails.group.name == null ||
        this.groupDetails.group.name == 0
      ) {
        this.$message({
          type: "error",
          message: "组名不能为空",
        });
        return;
      }

      if (this.groupAdd) {
        rejecthttp(
          true,
          "post",
          "/manage/fieldtrans/addgroup",
          this.groupDetails,
          this,
          (doc) => {
            changeflagCLOSED(doc, 0, this);
            if (doc.data.Code == "MSGKEY_OK") {
              this.$message({
                type: "sucess",
                message: doc.data.Message,
              });
              this.backToList();
            } else {
              this.$message({
                type: "error",
                message: doc.data.Message,
              });
            }
          }
        );
      } else {
        rejecthttp(
          true,
          "post",
          "/manage/fieldtrans/updategroup",
          this.groupDetails,
          this,
          (doc) => {
            changeflagCLOSED(doc, 0, this);
            if (doc.data.Code == "MSGKEY_OK") {
              this.$message({
                type: "sucess",
                message: doc.data.Message,
              });
              this.backToList();
            } else {
              this.$message({
                type: "error",
                message: doc.data.Message,
              });
            }
          }
        );
      }
    },

    editField(row) {
      this.selectRow = row.fieldid;
      this.fieldAdd = false;
      this.showFieldDetails = true;
      this.fieldDetails = JSON.parse(JSON.stringify(row));
      this.getTableField();
      this.$set(this.fieldDetails, "fieldid", this.selectRow);
    },

    deleteField(row) {
      let i = 0;
      for (i = 0; i < this.groupDetails.details.length; i++) {
        if (row.fieldid == this.groupDetails.details[i].fieldid) {
          break;
        }
      }
      this.groupDetails.details.splice(i, 1);
    },
  },

  mounted: function () {
    this.$nextTick(function () {
      if (this.$refs.table.$el !== "undefined")
        this.tableHeight =
          window.innerHeight - this.$refs.table.$el.offsetTop - 160;
          console.log(this.tableHeight);

      // 监听窗口大小变化
      let self = this;
      window.onresize = function () {
        self.tableHeight =
          window.innerHeight - self.$refs.table.$el.offsetTop - 160;
      };
    });
    //this.$refs.table.$el.offsetTop：表格距离浏览器的高度 //50表示你想要调整的表格距离底部的高度（你可以自己随意调整），因为我们一般都有放分页组件的，所以需要给它留一个高度
  },

  created() {
    this.resetFieldDetails();
    this.resetGroupDetails();
    this.typeOptions = userTableType.getData();
    this.refreshList();
  },
};
</script>

<style  scoped>
</style>


// WEBPACK FOOTER //
// src/pages/settings/SpecialExternalField.vue